import { KanbanState } from 'b2b-apps/core/kanban';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';
import { PlaceKanbanOrderDataType, VerifyKanbanItemsType } from 'b2b-common/core/kanban/Kanban.types';

export const getState = (state: State): KanbanState => state.kanban;

export const getVerifyKanbanItems = (
  state: State,
): RemoteRecord<VerifyKanbanItemsType> => new RemoteRecord(getState(state).verifyKanbanItems);

export const getAddKanbanItemsToCart = (
  state: State,
): RemoteRecord<AddItemsToCartType> => new RemoteRecord(getState(state).addItemsToCart);

export const getPlaceKanbanOrder = (
  state: State,
): RemoteRecord<PlaceKanbanOrderDataType> => new RemoteRecord(getState(state).placeKanbanOrder);
